import _ from 'lodash';
import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';
import { ADVANCED_CREATIVE_TYPE } from 'src/const/state/call-to-action';

export const INIT = {
  call_to_action_type: ADVANCED_CREATIVE_TYPE.default,
  call_to_action_id: undefined,
  call_to_action_list: [
    {
      call_to_action: '',
    },
  ],
};

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-cta',
    call_to_action_type: INIT.call_to_action_type,
    call_to_action_id: INIT.call_to_action_id,
    call_to_action_list: _.cloneDeep(INIT.call_to_action_list),
  },
  getters: {
    formItemData4Show(state) {
      return {
        call_to_action_type: state.call_to_action_type,
        call_to_action_id: state.call_to_action_id,
        call_to_action_list: state.call_to_action_list,
      };
    },
    formItemData4Hide() {
      return {
        call_to_action_id: INIT.call_to_action_id,
        call_to_action_type: INIT.call_to_action_type,
        call_to_action_list: [],
      };
    },
    // 由form group module的state控制是否展示call to action
    isVisible(state, getters) {
      return getters.formGroupState.showCta;
    },
  },
  mutations: {
    [types.ADD_PCD_CTA](state) {
      state.call_to_action_list.push({
        call_to_action: '',
      });
    },
    [types.DELETE_PCD_CTA](state, index) {
      state.call_to_action_list.splice(index, 1);
    },
    [types.CLEAR_PCD_CTA](state) {
      state.call_to_action_list = [];
    },
    [types.UPDATE_PCD_CTA](state, { index, value }) {
      const old = state.call_to_action_list[index];
      if (old) {
        delete old.reject_reason; // 变动标题时删除拒审理由
        state.call_to_action_list.splice(index, 1, {
          ...old,
          call_to_action: value,
        });
      }
    },
    [types.UPDATE_PCD_CTA_TYPE](state, type) {
      state.call_to_action_type = type;
    },
    [types.UPDATE_PCD_CTA_ID](state, ctaId) {
      state.call_to_action_id = ctaId;
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const { call_to_action_id, call_to_action_list = [] } = formData;
      commit('update', {
        call_to_action_id,
        call_to_action_list: call_to_action_list.length ? call_to_action_list : _.cloneDeep(INIT.call_to_action_list),
      });
    },
  },
});
